import React from 'react';

const Loader = () => {
  return (
    <div className="overlay">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
